
import $ from 'jquery';
import Flickity from 'flickity';


let sliders = {

  SliderTimeline : null,

  initSliderTimeline(){
    if( !$('#slider-timeline').length ){ return; }

    this.SliderTimeline = new Flickity( '#slider-timeline', {
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        freeScroll: true,
        //groupCells: true,
        //groupCells: 3,
        on: {
          ready: function() {
            $(this.element).css('opacity','1');
          },
          change: function(index) {
            //$(this.element).parent().find('.slider-counter #current-slide').html(index+1);
          },  
        } 
    });
  },

  initSliderSingle(){
    if( !$('.single-slider__slides').length ){ return; }

    this.SliderSingle = new Flickity( '.single-slider__slides', {
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        //freeScroll: true,
        on: {
          ready: function() {
            $(this.element).css('opacity','1');
          },
          change: function(index) {
            $(this.element).parent().find('.slider-counter #current-slide').html(index+1);
          },  
        } 
    });
  },
   
}
export default sliders;

